import { render, staticRenderFns } from "./ChatLocation.vue?vue&type=template&id=4aae50e4&scoped=true"
import script from "./ChatLocation.vue?vue&type=script&lang=js"
export * from "./ChatLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aae50e4",
  null
  
)

export default component.exports